import { Route } from 'react-router-dom';
import { routes } from '../../utils/helpers/ApiClient';
import CMSWrapper from '../CMSWrapper';
import {
  FjInterestedPage,
  FjInterestsEdit,
  FjJobsDetailPage,
  FjJobsEdit,
  FjJobsPage as FjJobsCMSPage,
  FjListMyInterestsPage,
  FjInterestDetailPage,
} from '../pages/CMSPages/index';
import React from 'react';

const FriJobsRoutes = () => (
  <>
    <Route
      path={routes.cmsFriJobsJobs}
      element={
        <CMSWrapper permissions={['fri-jobs-jobs.index']}>
          <FjJobsCMSPage />
        </CMSWrapper>
      }
    />

    <Route
      path={routes.cmsFriJobsJobCreate}
      element={
        <CMSWrapper permissions={['fri-jobs-jobs.store']}>
          <FjJobsEdit isCreate={true} />
        </CMSWrapper>
      }
    />

    <Route
      path={`${routes.cmsFriJobsJobEdit}/:jobId`}
      element={
        <CMSWrapper permissions={['fri-jobs-jobs.update']}>
          <FjJobsEdit isCreate={false} />
        </CMSWrapper>
      }
    />

    {/*FriJobs-my interest*/}
    <Route
      path={`${routes.cmsFriJobsInterestEdit}/:id`}
      element={
        <CMSWrapper permissions={['fri-jobs-student']}>
          <FjInterestsEdit mode={'edit'} />
        </CMSWrapper>
      }
    />

    <Route
      path={`${routes.cmsFriJobsInterestCreate}/:id`}
      element={
        <CMSWrapper permissions={['fri-jobs-student']}>
          <FjInterestsEdit mode={'create'} />
        </CMSWrapper>
      }
    />

    <Route
      path={`${routes.cmsFriJobsJobDetail}/:id`}
      element={
        <CMSWrapper permissions={['fri-jobs-jobs.show']}>
          <FjJobsDetailPage />
        </CMSWrapper>
      }
    />

    <Route
      path={`${routes.cmsFriJobsJobInterested}/:id`}
      element={
        <CMSWrapper permissions={['fri-jobs-jobs.show']}>
          <FjInterestedPage />
        </CMSWrapper>
      }
    />

    <Route
      path={`${routes.cmsFriJobsInterestCreate}/:id`}
      element={
        <CMSWrapper permissions={['fri-jobs-student']}>
          <FjInterestsEdit mode={'create'} />
        </CMSWrapper>
      }
    />

    <Route
      path={`${routes.cmsFriJobsMyInterests}`}
      element={
        <CMSWrapper permissions={['fri-jobs-student']}>
          <FjListMyInterestsPage />
        </CMSWrapper>
      }
    />

    <Route
      path={`${routes.cmsFriJobsInterestDetail}/:id`}
      element={
        <CMSWrapper permissions={['fri-jobs-student']}>
          <FjInterestDetailPage />
        </CMSWrapper>
      }
    />
  </>
);

export default FriJobsRoutes;
